import { Brand } from "./Brand";
const steps = [
  {
    title: "Submit",
    text: "Everyone drops a pick that fits the theme before the deadline.",
  },
  {
    title: "Vote",
    text: "Vote for your favorite picks.",
  },
  {
    title: "Reveal",
    text: "Picks are ranked, names come out, and the next round begins!",
  },
];
function SignInAction({ secondary = false }: { secondary?: boolean }) {
  return (
    <a
      className={secondary ? "button button-quiet" : "button button-primary"}
      href="#signin"
    >
      {secondary ? "Sign in" : "Sign in to Taste Test"}
    </a>
  );
}
export function Landing() {
  return (
    <>
      <a className="skip-link" href="#main">
        Skip to content
      </a>
      <header className="site-header">
        <a className="home-link" href="/" aria-label="Taste Test home">
          <Brand />
        </a>
        <SignInAction secondary />
      </header>
      <main id="main">
        <section className="hero section-wrap">
          <div className="hero-copy">
            <p className="eyebrow">Good friends. Questionable taste.</p>
            <h1>Who has the best taste?</h1>
            <p className="intro">
              Submit a pick for a themed round, vote anonymously, and find out
              who has the best taste.
            </p>
            <SignInAction />
            <p className="account-note">
              Sign in with your Atmosphere account.
            </p>
          </div>
          <div className="collage" aria-hidden="true">
            <div className="pick-preview">
              <div className="pick-meta">
                <span className="phase phase-vote">Voting</span>
                <span>Rank your top three</span>
              </div>
              <div className="track">
                <span className="record-art" />
                <div>
                  <strong>Electric Feel</strong>
                  <span>MGMT</span>
                </div>
              </div>
              <div className="points-preview">
                <span>1st choice</span>
                <strong>3 points</strong>
              </div>
            </div>
            <div className="results-preview">
              <p>Round 3 results</p>
              <div className="podium">
                {[
                  { initials: "JU", place: 2 },
                  { initials: "MA", place: 1 },
                  { initials: "DK", place: 3 },
                ].map(({ initials, place }) => (
                  <div className={`podium-player place-${place}`} key={place}>
                    <span className="avatar">{initials}</span>
                    <span className="podium-bar">{place}</span>
                  </div>
                ))}
              </div>
            </div>
            <span className="confetti confetti-one" />
            <span className="confetti confetti-two" />
          </div>
        </section>
        <section className="test-section" aria-labelledby="test-heading">
          <div className="section-wrap">
            <p className="eyebrow">Two tests to start</p>
            <h2 id="test-heading">Pick a test, then pick a theme</h2>
            <div className="test-grid">
              <article className="test-card music">
                <span className="test-icon" aria-hidden="true">
                  ♫
                </span>
                <h3>Music Test</h3>
                <p>
                  Picks are songs. Bring a track link from the service you
                  listen on and share it with your friends.
                </p>
                <div className="theme-example">
                  <span className="eyebrow">Example theme</span>
                  <strong>A song that sounds like a road trip</strong>
                </div>
              </article>
              <article className="test-card skeet">
                <span className="test-icon" aria-hidden="true">
                  ✦
                </span>
                <h3>Skeet Test</h3>
                <p>
                  Picks are Bluesky posts. Yours or anyone’s, as long as it fits
                  the theme. The post author stays visible.
                </p>
                <div className="theme-example">
                  <span className="eyebrow">Example theme</span>
                  <strong>Best skeet of the week</strong>
                </div>
              </article>
            </div>
          </div>
        </section>
        <section
          className="how-section section-wrap"
          aria-labelledby="how-heading"
        >
          <p className="eyebrow">How a round works</p>
          <h2 id="how-heading">Three phases, then the next theme</h2>
          <ol className="steps">
            {steps.map((step, i) => (
              <li key={step.title}>
                <span className={`step-number step-${i}`} aria-hidden="true">
                  {i + 1}
                </span>
                <div>
                  <h3>{step.title}</h3>
                  <p>{step.text}</p>
                </div>
              </li>
            ))}
          </ol>
        </section>
        <section
          className="closing section-wrap"
          id="preview"
          aria-labelledby="preview-heading"
        >
          <span className="phase phase-soon">Now available</span>
          <h2 id="preview-heading">Start the test with your friends</h2>
          <p>
            Create a private test, invite your friends, and play a themed
            round. Sign in to get started.
          </p>
          <p>Taste Test runs on <a href="https://atprotocol.com" target="_blank" rel="noopener noreferrer">ATProto</a>, the open network behind Bluesky.</p>
        </section>
      </main>
      <footer className="site-footer">
        <Brand />
        <span>Made for your group chat.</span>
      </footer>
    </>
  );
}
